<template>
    <v-container fluid class="page-profilo">

        <!-- Header -->
        <div class="page-header">
            <div class="header-title">
                <v-icon color="primary" size="28">mdi-account-cog-outline</v-icon>
                <h1>Profilo</h1>
            </div>
        </div>

        <v-card class="profilo-card elevation-2">
            <!-- Tabs -->
            <v-tabs v-model="activeTab" color="primary" @update:model-value="changeTab">
                <v-tab value="utente">
                    <v-icon start>mdi-account</v-icon>
                    Utente
                </v-tab>
                <v-tab value="azienda">
                    <v-icon start>mdi-domain</v-icon>
                    Azienda
                </v-tab>
                <v-tab value="api" v-if="role !== 2">
                    <v-icon start>mdi-api</v-icon>
                    API
                </v-tab>
                <v-tab value="licenza">
                    <v-icon start>mdi-file-certificate</v-icon>
                    Licenza e Fatturazione
                </v-tab>
            </v-tabs>

            <v-divider />

            <v-window v-model="activeTab">

                <!-- TAB UTENTE -->
                <v-window-item value="utente">
                    <tab-utente :utente="utente" @update:utente="utente = $event" />
                </v-window-item>

                <!-- TAB AZIENDA -->
                <v-window-item value="azienda">
                    <tab-azienda :azienda="azienda" />
                </v-window-item>

                <!-- TAB API -->
                <v-window-item value="api">
                    <tab-api :api-key="apiKey" @reload-data="load" @api-disabled="apiKey = null"
                        @api-regenerated="apiKey = $event" />
                </v-window-item>

                <!-- TAB LICENZA -->
                <v-window-item value="licenza">
                    <tab-licenza-fatturazione />
                </v-window-item>

            </v-window>

        </v-card>

    </v-container>
</template>


<script>
import { mapGetters } from 'vuex'

import TabUtente from '@/components/profilo/TabUtente.vue'
import TabAzienda from '@/components/profilo/TabAzienda.vue'
import TabApi from '@/components/profilo/TabApi.vue'
import TabLicenzaFatturazione from '@/components/profilo/TabLicenzaFatturazione.vue'

import { get_dati_utente } from "@/api/api.profilo"

export default {
    name: "ProfiloUtente",

    components: {
        TabUtente,
        TabAzienda,
        TabApi,
        TabLicenzaFatturazione
    },

    data() {
        return {
            activeTab: "utente",
            utente: {
                username: "",
                email: ""
            },
            azienda: {
                ragioneSociale: "",
                pIva: ""
            },
            apiKey: null
        }
    },

    computed: {
        ...mapGetters('user', {
            role: 'getRole'
        })
    },

    watch: {
        '$route.params.tab': {
            immediate: true,
            handler(newTab) {
                if (newTab && this.isValidTab(newTab)) {
                    this.activeTab = newTab
                }
            }
        }
    },

    mounted() {
        this.load()

        // Carica la tab dall'URL se presente
        const tabFromUrl = this.$route.params.tab
        if (tabFromUrl && this.isValidTab(tabFromUrl)) {
            this.activeTab = tabFromUrl
        }
    },

    methods: {
        isValidTab(tab) {
            const validTabs = ['utente', 'azienda', 'api', 'licenza']
            // Se il ruolo è 2, API non è valida
            if (tab === 'api' && this.role === 2) {
                return false
            }
            return validTabs.includes(tab)
        },

        changeTab(newTab) {
            // Aggiorna l'URL quando cambia la tab
            if (this.$route.params.tab !== newTab) {
                this.$router.push({ name: 'profilo', params: { tab: newTab } })
            }
        },

        async load() {
            try {
                const res = await get_dati_utente()
                this.utente = res.data.utente
                this.azienda = res.data.azienda
                this.apiKey = res.data.apiKey ?? null
            } catch (err) {
                console.error("Errore nel caricamento del profilo:", err)
            }
        }
    }
}
</script>


<style scoped>
.page-profilo {
    max-width: 1000px;
    margin: auto;
    padding: 24px 16px;
}

.page-header {
    margin-bottom: 24px;
}

.header-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-title h1 {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
}

.profilo-card {
    border-radius: 12px;
    overflow: hidden;
}
</style>